import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const PartnerInfo = ({ partner }) => {
  return (
    <Box>
      {/* Row 1: 거래처 종류 / 산업체 유형 */}
      <Grid
        container
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}>
          <Typography variant="subtitle2">거래처 종류</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">{partner?.partnerTyp}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2">산업체 유형</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">{partner?.incTyp}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2">거래처명</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">{partner?.partnerNm}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2">대표자명</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">{partner?.president}</Typography>
        </Grid>
      </Grid>
      {/* Row 3: 사업자번호 / 주요 품목 */}
      <Grid
        container
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}>
          <Typography variant="subtitle2">사업자번호</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">{partner?.regNumber}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2">연락처</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">{partner?.partnerPhone}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2">주소</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
            {partner?.partnerAddr}
          </Typography>
        </Grid>
      </Grid>

      {/* Row 4: 업태 / 종목 */}
      <Grid
        container
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}>
          <Typography variant="subtitle2">거래개시일</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">
            {partner?.accountOpenDate}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2">계산서 접수 이메일</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">
            {partner?.taxEmail}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2">은행명</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">{partner?.bankName}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2">계좌번호</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2">{partner?.accountNumber}</Typography>
        </Grid>
        
      </Grid>

      {/* Row 5: 연락처 / 거래개시일
      <Grid
        container
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={1}>
          <Typography variant="subtitle2">업태</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2">{partner?.businessStatus}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2">종목</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2">{partner?.businessTyp}</Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="subtitle2">주요 품목</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2">{partner?.mainItemDesc}</Typography>
        </Grid>
        
      </Grid>
      */}
      {/* Row 8: 참고사항 */}
      <Grid
        container
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ py: 1 }}
      >
        <Grid item xs={1}>
          <Typography variant="subtitle2">참고사항</Typography>
        </Grid>
        <Grid item xs={11}>
          <Typography
            variant="body2"
            sx={{ whiteSpace: 'pre-line' }}
          >
            {partner?.partnerDesc}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PartnerInfo;